import axios from 'axios';
import Cookies from 'js-cookie';

// Base API URL
const API_URL = import.meta.env.VITE_API_URL + '/api';

// Create Axios instance
const api = axios.create({
    baseURL: API_URL,
    // Default to JSON; we'll override for FormData when needed
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add Authorization header from cookie
api.interceptors.request.use(
    (config) => {
        const user = Cookies.get('islam101_user');
        if (user) {
            try {
                const parsedUser = JSON.parse(user);
                if (parsedUser.token) {
                    config.headers.Authorization = `Bearer ${parsedUser.token}`;
                }
            } catch (e) {
                console.error('Failed to parse user cookie:', e);
            }
        }

        // If the request data is FormData, let Axios set the Content-Type automatically
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default api;
